<template>
  <div>
    <div class="main-container">
      <div class="page-heading d-flex align-items-center">
        <img
          @click="goBack"
          src="../../assets/bckarrow.svg"
          class="pointer"
          alt=""
        />
        <div class="main-head ml-4">
          <span>Candidate Details</span>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="cd-left-container d-flex flex-column justify-content-between"
        >
          <div style="padding: 10px">
            <div class="cd-detail-box mt-1 ml-1 mr-1 mb-1">
              <div class="d-flex justify-content-between">
                <div style="width: 70%">
                  <div class="cd-title-text">Basic Details</div>
                  <b-row class="mt-3">
                    <b-col cols="5">
                      <div class="mg-right-subhead">First Name</div>
                    </b-col>
                    <b-col cols="5">
                      <div class="mg-right-subhead">Last Name</div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col cols="5">
                      <div class="mg-right-subcontent">
                        {{ candidateData.firstName }}
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="mg-right-subcontent">
                        {{ candidateData.lastName }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="5">
                      <div class="mg-right-subhead">Mail ID</div>
                    </b-col>
                    <b-col cols="5">
                      <div class="mg-right-subhead">Contact Number</div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col cols="5">
                      <div class="mg-right-subcontent">
                        {{ candidateData.email }}
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="mg-right-subcontent">
                        {{ candidateData.phoneNumber }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="5">
                      <div class="mg-right-subhead">D.O.B</div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1">
                    <b-col cols="5">
                      <div class="mg-right-subcontent">
                        {{
                          candidateData.dateOfBirth.substring(0, 10)
                            | formatdate
                        }}
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <div>
                  <img src="../../assets/img/hrportal/dummyface.svg" alt="" />
                </div>
              </div>
            </div>

            <div class="cd-detail-box mt-4">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDropDown(0)"
              >
                <div class="cd-title-text">JD Details</div>
                <div>
                  <img
                    v-if="!dropDownToggle[0]"
                    src="../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>

              <div v-if="dropDownToggle[0]">
                <div class="cd-jd-info">
                  <b-row>
                    <b-col cols="4">
                      <div class="mg-right-subhead">JD Name</div>
                    </b-col>
                    <b-col cols="4">
                      <div class="mg-right-subhead">Created By</div>
                    </b-col>
                    <b-col cols="4">
                      <div class="mg-right-subhead">Approved By</div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <div class="mg-right-subcontent">
                        {{ jdDetails.name }}
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="mg-right-subcontent">
                        {{ jdDetails.initiatedBy }}
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="mg-right-subcontent">
                        {{ jdDetails.approvedBy }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="4">
                      <div class="mg-right-subhead">Recruiter Name</div>
                    </b-col>
                    <b-col cols="4">
                      <div class="mg-right-subhead">Selected By</div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="4">
                      <div class="mg-right-subcontent">{{ recruiterName }}</div>
                    </b-col>
                    <b-col cols="4">
                      <div class="mg-right-subcontent">
                        {{ jdDetails.selectedBy }}
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <div class="d-flex flex-wrap">
                  <div
                    class="cd-round-cards pointer"
                    v-for="(jd, index) in jdDetails.progress"
                    :key="index"
                    @click="openModal(index, jd.type)"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="d-flex">
                        <div>
                          <img
                            v-if="jd.type == 'assesment'"
                            src="../../assets/img/hrportal/assessment.svg"
                            alt=""
                          />
                          <img
                            v-else
                            src="../../assets/img/hrportal/f2f.svg"
                            alt=""
                          />
                        </div>
                        <div class="ml-2">
                          <span
                            v-if="jd.type == 'assesment'"
                            class="cd-type-head"
                            >Assessment</span
                          >
                          <span v-else class="cd-type-head">Face to Face</span>
                        </div>
                      </div>

                      <div class="cd-type-head" style="font-weight: 400">
                        {{ jd.roundName }}
                      </div>
                    </div>

                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        mt-3
                      "
                    >
                      <div>
                        <span
                          v-if="jd.type == 'assesment'"
                          class="cd-type-desc-head"
                          >Test Name</span
                        >
                        <span v-else class="cd-type-desc-head">Duration</span>
                      </div>
                      <div class="cd-date-text">
                        Date :
                        <span style="font-weight: 400">{{
                          jd.interviewDetails[0].endTime.substring(0, 10)
                            | formatdate
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div>
                        <span
                          v-if="jd.type == 'assesment'"
                          class="cd-test-name"
                          >{{ jd.interviewDetails[0].testName }}</span
                        >
                        <span v-else class="cd-test-name"
                          >{{ jd.duration }} mins</span
                        >
                      </div>

                      <div>
                        <span
                          v-if="
                            jd.interviewDetails[0].recommendation == 'S' ||
                            jd.interviewDetails[0].recommendation == 'F'
                          "
                          class="cd-round-status"
                          style="color: #038e00"
                          >Selected</span
                        >
                        <span
                          v-else
                          class="cd-round-status"
                          style="color: #d90606"
                          >Rejected</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="cd-detail-box mt-4">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDropDown(1)"
              >
                <div class="cd-title-text">Round Details</div>
                <div>
                  <img
                    v-if="!dropDownToggle[1]"
                    src="../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>

              <div class="cd-round-drop mt-2" v-if="dropDownToggle[1]">
                <div
                  class="cd-hr-round mt-4"
                  v-for="(hr, index) in candidateData.activity"
                  :key="index"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div class="cd-doc-name">
                      <span
                        v-if="
                          hr.movedTo == '2' ||
                          hr.movedTo == '3' ||
                          hr.movedTo == '1' ||
                          hr.movedTo == '11'
                        "
                      >
                        Offer letter shared
                      </span>
                      <span v-else-if="hr.movedTo == '0'">
                        Offer letter initialization
                      </span>
                      <span v-else-if="hr.movedTo == '4'">
                        Assign on-boarding docs
                      </span>
                      <span v-else-if="hr.movedTo == '6' || hr.movedTo == '7'">
                        On-boarding documents are assigned
                      </span>
                      <span v-else-if="hr.movedTo == '10'">
                        Not interested by HR
                      </span>
                    </div>
                    <div>
                      <div v-if="hr.movedTo == '0'" class="cd-reject-text">
                        {{ hr.status }}
                      </div>
                      <div v-else-if="hr.movedTo == '1'" class="cd-reject-text">
                        Rejected by Opshead
                      </div>
                      <div v-else-if="hr.movedTo == '2'" class="cd-wait-text">
                        Waiting for Opshead approval
                      </div>
                      <div
                        v-else-if="hr.movedTo == '3'"
                        style="color: #038e00"
                        class="cd-accept-text"
                      >
                        Accepted by Opshead
                      </div>
                      <div v-else-if="hr.movedTo == '4'" class="cd-accept-text">
                        Offer accepted by candidate
                      </div>
                      <div v-else-if="hr.movedTo == '6'" class="cd-accept-text">
                        Docs assigned by HR
                      </div>
                      <div v-else-if="hr.movedTo == '7'" class="cd-accept-text">
                        Documents uploaded by candidate
                      </div>
                      <div
                        v-else-if="hr.movedTo == '10' || hr.movedTo == '11'"
                        class="cd-reject-text"
                      >
                        {{ hr.status }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div class="d-flex align-items-center mt-2">
                      <div class="cd-type-desc-head">Date</div>
                      <div class="mg-right-subcontent ml-3">
                        {{ hr.At.substring(0, 10) | formatdate }}
                      </div>
                      <div class="cd-type-desc-head ml-4">Confirmed By</div>
                      <div class="mg-right-subcontent ml-3">{{ hr.name }}</div>
                    </div>

                    <div>
                      <div v-if="hr.movedTo == '3'" class="cd-wait-text">
                        Waiting for candidate response
                      </div>
                      <div v-else-if="hr.movedTo == '4'" class="cd-next-text">
                        Docs not yet assigned by HR
                      </div>
                      <div v-else-if="hr.movedTo == '6'" class="cd-wait-text">
                        Not yet uploaded by candidate
                      </div>
                      <div v-else-if="hr.movedTo == '7'" class="cd-wait-text">
                        Review onboarding documents
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mt-2">
                    <div>
                      <img
                        src="../../assets/img/hrportal/userdefault.svg"
                        alt=""
                      />
                    </div>
                    <div class="cd-options-text ml-3">
                      {{
                        candidateData.firstName + " " + candidateData.lastName
                      }}
                    </div>
                  </div>

                  <div
                    class="mt-2 cd-options-text"
                    v-if="hr.remarks != ''"
                    style="color: #696969"
                  >
                    Remarks :
                    <span class="mg-right-subcontent">{{ hr.remarks }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cd-right-container ml-2">
          <div
            class="wb-right-emptytextalignment"
            v-if="
              candidateData.offerLetter == null &&
              attached.length > 0 &&
              declaration.length > 0
            "
          >
            <img
              src="../../assets/img/hrportal/noCandidateDetails.svg"
              alt=""
            />
          </div>
          <div
            v-if="
              candidateData.offerLetter != null ||
              attached.length > 0 ||
              declaration.length > 0
            "
          >
            <div class="cd-form-headings">View Attached Documents</div>
            <div class="cd-attach-list mt-4">
              <div
                class="d-flex align-items-center justify-content-between"
                v-if="candidateData.offerLetter"
              >
                <div class="cd-form-headings">Offer Letter</div>
                <div class="pointer" @click="openOfferLetter">
                  <img
                    v-b-popover.hover.top="'View'"
                    src="../../assets/img/hrportal/eyeicon.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="cd-attach-list mt-2" v-if="attached.length > 0">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDocs(0)"
              >
                <div class="cd-form-headings">Attach documents</div>
                <div>
                  <img
                    v-if="!docsToggle[0]"
                    src="../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div class="cd-attach-doc-list" v-if="docsToggle[0]">
                <hr />
                <div
                  v-for="(doc, index) in attached"
                  :key="index"
                  class="
                    cd-docs-container
                    d-flex
                    align-items-center
                    justify-content-between
                    mb-2
                  "
                >
                  <div class="d-flex align-items-center">
                    <img
                      src="../../assets/img/registration/adPdfIcon.svg"
                      alt=""
                    />
                    <div class="cd-doc-name ml-2">{{ doc.name }}</div>
                  </div>
                  <div class="pointer" @click="openViewDocument('doc', index)">
                    <img src="../../assets/img/hrportal/eyeicon.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div class="cd-attach-list mt-2" v-if="declaration.length > 0">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDocs(1)"
              >
                <div class="cd-form-headings">Declaration documents</div>
                <div>
                  <img
                    v-if="!docsToggle[1]"
                    src="../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div class="cd-attach-doc-list" v-if="docsToggle[1]">
                <hr />
                <div
                  v-for="(doc, index) in declaration"
                  :key="index"
                  class="
                    cd-docs-container
                    d-flex
                    align-items-center
                    justify-content-between
                    mb-2
                  "
                >
                  <div class="d-flex align-items-center">
                    <img
                      src="../../assets/img/registration/adPdfIcon.svg"
                      alt=""
                    />
                    <div class="cd-doc-name ml-2">{{ doc.name }}</div>
                  </div>
                  <div class="pointer" @click="openViewDocument('dec', index)">
                    <img src="../../assets/img/hrportal/eyeicon.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="document"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="md"
      @hidden="$bvModal.hide('document')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">{{ activeDoc.name }}</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('document')">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <div>
        <pdf
          style="border: 1px solid black"
          v-if="activeDoc.source != ''"
          :src="activeDoc.source"
          alt=""
        ></pdf>
      </div>
    </b-modal>

    <b-modal
      id="faceToFace"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="md"
      @hidden="$bvModal.hide('faceToFace')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Face To Face</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('faceToFace')">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <div class="cd-f2f-cont">
        <div class="d-flex align-items-center">
          <div class="cd-round-red">
            <img src="../../assets/img/hrportal/f2f.svg" alt="" />
          </div>
          <div class="cd-test-name ml-2">Face to Face</div>
        </div>

        <div class="d-flex align-items-center justify-content-between mt-3">
          <div class="cd-type-desc-head">Duration</div>
          <div class="cd-date-text" v-if="activeRound.date">
            Date :
            <span style="font-weight: 400">{{
              activeRound.date.substring(0, 10)
            }}</span>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mt-1">
          <div class="cd-test-name">{{ duration }} mins</div>
          <div
            v-if="
              activeRound.recommendation == 'S' ||
              activeRound.recommendation == 'F'
            "
            class="cd-round-status"
            style="color: #038e00"
          >
            Selected
          </div>
          <div v-else class="cd-round-status" style="color: #d90606">
            Rejected
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mt-3">
          <div class="cd-type-desc-head">Panelist</div>
          <div class="cd-type-desc-head">Recruitment</div>
        </div>

        <div class="d-flex align-items-center justify-content-between mt-1">
          <div
            class="cd-test-name"
            v-if="activeRound.externalPanelist.length == 0"
          >
            {{ activeRound.panelist.name }}
          </div>
          <div class="cd-test-name" v-else>-</div>
          <div class="cd-test-name">{{ activeRound.processedBy }}</div>
        </div>

        <hr />
        <div
          class="cd-external-list"
          v-if="activeRound.externalPanelist.length > 0"
        >
          <div class="cd-type-desc-head">External Panelist</div>
          <div
            class="d-flex align-items-center mt-2"
            v-for="(ext, index) in activeRound.externalPanelist"
            :key="index"
          >
            <div>
              <img src="../../assets/img/hrportal/userdefault.svg" alt="" />
            </div>
            <div class="ml-2 cd-ext-pan">{{ ext }}</div>
          </div>
        </div>
      </div>

      <div class="cd-view-fdbk pointer" @click="openFeedbackModal">
        <div class="mg-right-subcontent">View Feedback</div>
        <div>
          <img src="../../assets/img/hrportal/viewhist.svg" alt="" />
        </div>
      </div>
    </b-modal>

    <b-modal id="marks" centered hide-footer hide-header class="p-0" size="md" @hidden="$bvModal.hide('marks')">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Marks</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('marks')">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <div class="cd-info">
        <div class="mg-right-subcontent">Name</div>
        <div class="cd-doc-name">{{ activeRound.candidate.name }}</div>
      </div>

      <div class="cd-detail-container mt-2">
        <div class="cd-top-cont">
          <div class="d-flex align-items-center">
            <div class="cd-round-green">
              <img src="../../assets/img/hrportal/assessmentmodal.svg" alt="" />
            </div>
            <div class="cd-test-name ml-2">Assessment</div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-3">
            <div>
              <span class="cd-type-desc-head">Test Name</span>
            </div>
            <div class="cd-date-text">
              Date :
              <span style="font-weight: 400">{{
                activeRound.endTime.substring(0, 10)
              }}</span>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-1">
            <div class="cd-test-name">{{ activeRound.testName }}</div>
            <div
              v-if="
                activeRound.recommendation == 'S' ||
                activeRound.recommendation == 'F'
              "
              class="cd-round-status"
              style="color: #038e00"
            >
              Selected
            </div>
            <div v-else class="cd-round-status" style="color: #d90606">
              Rejected
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-1">
            <div>
              <img src="../../assets/img/hrportal/viewresult.svg" alt="" />
              <span class="cd-type-desc-head">Marks</span>
            </div>
            <div>
              <span class="cd-type-desc-head">Total Marks :</span>
              <span class="cd-test-name"
                >{{ activeRound.marks }}/{{ activeRound.totalMarks }}</span
              >
            </div>
          </div>
        </div>
        <div class="cd-bottom-cont">
          <div class="cd-marks-list">
            <div
              class="cd-section-marks"
              v-for="(section, index) in activeRound.testResponse"
              :key="index"
            >
              <div class="mg-right-subcontent">{{ section.sectionName }}</div>
              <div
                class="cd-options-text"
                :style="{ color: '#' + Math.random().toString(16).slice(-6) }"
              >
                {{ section.sectionMarks }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cd-view-fdbk pointer" @click="openFeedbackModal">
        <div class="mg-right-subcontent">View Feedback</div>
        <div>
          <img src="../../assets/img/hrportal/viewhist.svg" alt="" />
        </div>
      </div>
    </b-modal>

    <b-modal
      id="feedback"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="lg"
      @hidden="$bvModal.hide('feedback')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Feedback form</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('feedback')">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <div class="cd-feedback-body">
        <div class="cd-feedback-head">Basic info</div>

        <div class="mt-4 p-4 cd-basic-cont">
          <b-row>
            <b-col cols="6">
              <div class="topDiv">
                <label class="fieldsetStyle">Candidate Name</label>
                <b-form-input
                  class="emailinputField"
                  id="input-1"
                  type="text"
                  disabled
                  v-model="activeRound.candidate.name"
                >
                </b-form-input>
              </div>
            </b-col>

            <b-col cols="6">
              <div class="topDiv">
                <label class="fieldsetStyle">Evaluation Date</label>
                <b-form-input
                  class="emailinputField"
                  id="input-1"
                  type="text"
                  v-model="activeRound.feedback.createdAt"
                  disabled
                >
                </b-form-input>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col cols="6">
              <div class="topDiv">
                <label class="fieldsetStyle">Panel Name</label>
                <b-form-input
                  class="emailinputField"
                  id="input-1"
                  type="text"
                  v-model="activeRound.feedback.panelName"
                  disabled
                >
                </b-form-input>
              </div>
            </b-col>

            <b-col cols="6">
              <div class="topDiv">
                <label class="fieldsetStyle">Experience (in years)</label>
                <b-form-input
                  class="emailinputField"
                  id="input-1"
                  type="text"
                  disabled
                >
                </b-form-input>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-4" v-if="activeRound.interviewRound.type == 'f2f'">
            <b-col cols="6">
              <div class="topDiv">
                <label class="fieldsetStyle"
                  >Mode Of Interview (Web CAM / T-COM)</label
                >
                <b-form-input
                  class="emailinputField"
                  id="input-1"
                  placeholder="Enter name"
                  type="text"
                  value="WebCAM"
                  disabled
                >
                </b-form-input>
              </div>
            </b-col>

            <b-col cols="6"> </b-col>
          </b-row>

          <div
            v-for="(skill, index) in activeRound.feedback.customFeedback.skills"
            :key="index"
            class="p-4 cd-fbs mt-2"
          >
            <div class="cd-doc-name" style="color: #545454">
              {{ skill.name }}
            </div>
            <div class="topDiv mt-4" v-if="skill.comments != ''">
              <label class="fieldsetStyle">Remarks</label>
              <b-form-textarea
                class="emailinputField"
                id="input-1"
                rows="3"
                type="text"
                placeholder="Enter Remarks . . ."
                max-rows="6"
                disabled
                v-model="skill.comments"
              >
              </b-form-textarea>
            </div>
            <div
              class="candviewmodalinput relativeclass"
              v-if="skill.markingType == 'rating'"
            >
              <label class="mt-2 formtext-value">Rating</label>
              <b-form-rating
                variant="primary"
                v-model="skill.mark"
                class="mb-2 scorerate w-25"
                disabled
              ></b-form-rating>
            </div>
            <b-row
              class="candviewmodalinput"
              v-if="skill.markingType == 'score'"
            >
              <b-col cols="6">
                <div class="topDiv mt-3">
                  <label class="fieldsetStyle">Score (out of 10) &nbsp;</label>
                  <b-form-input
                    v-model="skill.mark"
                    class="emailinputField"
                    id="input-1"
                    type="text"
                    disabled
                  >
                  </b-form-input>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="offer-letter"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="lg"
      @hidden="$bvModal.hide('offer-letter')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Offer Letter</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('offer-letter')">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <div
        class="cd-basic-cont cd-template-card"
        v-html-safe="candidateData.offerLetter"
      ></div>
    </b-modal>
  </div>
</template>

<script>
import { getofferletter, getJDProgress } from "../../utils/apiFunctions";
import pdf from "vue-pdf";
export default {
  name: "CandidateDetails",
  components: {
    pdf,
  },
  data() {
    return {
      //NUMBERS
      sections: 20,
      externalPan: 3,

      //STRINGS
      duration: "",
      recruiterName: "",
      //BOOLEAN

      //OBJECTS
      candidateData: {
        dateOfBirth: "",
      },
      jdDetails: {},
      activeDoc: {},
      activeRound: {
        date: "",
        externalPanelist: [],
        panelist: {
          name: "",
        },
        candidate: {
          name: "",
        },
        interviewRound: {
          type: "",
        },
        feedback: {
          createdAt: "",
          panelName: "",
          customFeedback: {
            skills: [{ name: "", comments: "" }],
          },
        },
        endTime: "",
        marks: "",
        totalMarks: "",
      },

      // ARRAY
      dropDownToggle: [false, false],
      docsToggle: [false, false],
      declaration: [],
      attached: [],
    };
  },
  filters: {
    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
  },
  created() {
    this.getCandidateDetails();
  },
  methods: {
    // ASYNCHRONOUS FUNCTION BLOCK
    // GET CANDIDATE DETAIL
    async getCandidateDetails() {
      try {
        const response = await getofferletter(this.$route.params.candidateID);
        this.candidateData = response.data.data;
        let payload = {
          candidateID: this.candidateData.RecCandidateID,
          jobID: this.candidateData.jobDetails.jobID,
        };
        await this.getJdDetails(payload);
        let documentsDec = response.data.data.document.decForm;
        let docs = response.data.data.document.documents;
        let uploaded = response.data.data.uploadedDocs;
        for (let i in documentsDec) {
          for (let j in uploaded) {
            if (uploaded[j].documentName == documentsDec[i].value) {
              this.declaration.push({
                name: documentsDec[i].name,
                value: documentsDec[i].value,
                source: uploaded[j].source[0],
              });
              break;
            }
          }
        }
        for (let i in docs) {
          for (let j in uploaded) {
            if (uploaded[j].documentName == docs[i].value) {
              this.attached.push({
                name: docs[i].name,
                value: docs[i].value,
                source: uploaded[j].source[0],
              });
              break;
            }
          }
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    async getJdDetails(payload) {
      try {
        const response = await getJDProgress(payload);
        this.jdDetails = response.data.data[0];
        let i = 0;
        while (i < this.jdDetails.progress.length) {
          if (this.jdDetails.progress[i].interviewDetails.length == 0) {
            this.jdDetails.progress.splice(i, 1);
          } else {
            if (this.recruiterName == "") {
              this.recruiterName =
                this.jdDetails.progress[i].interviewDetails[0].processedBy;
            }
            i++;
          }
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // HELPER FUNCTIONS FOR TOGGLING DOCS LIST
    toggleDropDown(index) {
      this.dropDownToggle[index] = !this.dropDownToggle[index];
      let current = this.dropDownToggle[index];
      for (let i in this.dropDownToggle) {
        if (i != index) {
          if (current) {
            this.dropDownToggle[i] = false;
          }
        }
      }
      this.$forceUpdate();
    },

    toggleDocs(index) {
      this.docsToggle[index] = !this.docsToggle[index];
      let current = this.docsToggle[index];
      for (let i in this.docsToggle) {
        if (i != index) {
          if (current) {
            this.docsToggle[i] = false;
          }
        }
      }
      this.$forceUpdate();
    },

    // HELPER FUNCTIONS FOR B-MODALS
    // OPEN JD ROUND MODALS
    openModal(index, type) {
      this.activeRound = {
        ...this.jdDetails.progress[index].interviewDetails[0],
      };
      if (type == "assesment") {
        this.$bvModal.show("marks");
      } else {
        this.duration = this.jdDetails.progress[index].duration;
        this.$bvModal.show("faceToFace");
      }
    },

    // OPEN FEEDBACK MODEL
    openFeedbackModal() {
      this.activeRound.feedback.createdAt =
        this.activeRound.feedback.createdAt.substring(0, 10);
      if (Object.keys(this.activeRound.feedback.customFeedback).length == 0) {
        window.open(this.activeRound.feedback.panelFeedbackForm);
      } else {
        if (this.activeRound.feedback.panelName == "undefined") {
          this.activeRound.feedback.panelName = "-";
        }
        this.$bvModal.show("feedback");
      }
    },

    // OPEN OFFER LETTER MODAL
    openOfferLetter() {
      this.$bvModal.show("offer-letter");
    },

    // VIEW DOCUMENTS IN A MODAL
    openViewDocument(flag, index) {
      if (flag == "doc") {
        this.activeDoc = this.attached[index];
        this.$bvModal.show("document");
      } else {
        this.activeDoc = this.declaration[index];
        this.$bvModal.show("document");
      }
    },

    // HELPER FUNCTION FOR NAVIGATION
    goBack() {
      this.$router.push({
        name: this.$route.query.redirect,
        query: {
          status: this.$route.query.status,
        },
      });
    },
  },
};
</script>

<style>
.cd-round-drop {
  max-height: calc(100vh - 305px);
  overflow: auto;
}
.cd-reject-text {
  font-weight: 400;
  font-size: 14px;
  color: var(--cv-red);
  text-transform: capitalize;
}
.cd-accept-text {
  font-weight: 400;
  font-size: 14px;
  color: #038e00;
  text-transform: capitalize;
}
.cd-wait-text {
  font-weight: 400;
  font-size: 14px;
  color: #ffc145;
  text-transform: capitalize;
}
.cd-next-text {
  font-weight: 400;
  font-size: 14px;
  color: #c4c4c4;
  text-transform: capitalize;
}
.cd-template-card {
  background: white;
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 0px 30px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  margin-top: 10px;
}
.cd-basic-cont {
  min-height: auto;
  max-height: calc(100vh - 250px);
  overflow: auto;
}
.cd-fbs {
  padding: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.cd-feedback-body {
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.cd-feedback-head {
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-weight: 600;
  font-size: 13px;
  width: 100%;
  color: #ffffff;
  height: 45px;
  background: #84abe3;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px 8px 0px 0px;
}

.cd-external-list {
  max-height: 385px;
  overflow: auto;
}

.cd-view-fdbk {
  padding: 10px;
  margin-top: 10px;
  background: #f4f4f4;
  border: 0.7px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cd-ext-pan {
  font-weight: 600;
  font-size: 11px;
  color: #696969;
}

.cd-f2f-cont {
  padding: 10px;
  background: #f4f4f4;
  border: 0.7px solid #e5e5e5;
}

.cd-section-marks {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.cd-round-green {
  height: 50px;
  width: 50px;
  background: #ffeac1;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-round-red {
  height: 50px;
  width: 50px;
  background: #fdd9d9;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-marks-list {
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}

.cd-bottom-cont {
  padding: 10px;
  max-height: 430px;
  overflow: auto;
}

.cd-top-cont {
  padding: 10px;
  height: 170px;
  background: #f4f4f4;
  border: 0.7px solid #e5e5e5;
}

.cd-detail-container {
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
  border-radius: 5px;
}

.cd-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
  border-radius: 5px;
  padding: 10px;
}

.cd-hr-round {
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  border-radius: 5px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}

.cd-round-status {
  font-weight: 400;
  font-size: 14px;
}

.cd-date-text {
  font-weight: 500;
  font-size: 10px;
  color: #6d6d6d;
}

.cd-type-desc-head {
  font-weight: 400;
  font-size: 12px;
  color: #6d6d6d;
}

.cd-test-name {
  font-size: 13px;
  font-weight: 500;
  color: #6d6d6d;
}

.cd-type-head {
  font-size: 13px;
  font-weight: 500;
  color: #6d6d6d;
}

.cd-round-cards {
  width: 385px;
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 0px 10px rgba(216, 216, 216, 0.27);
  border-radius: 5px;
  margin-left: 7px;
  margin-top: 10px;
  padding: 15px;
}

.cd-jd-info {
  background: #fbfbfb;
  border-radius: 8px;
  width: 100%;
  margin-top: 15px;
  padding: 10px 15px;
}

.cd-options-text {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.cd-doc-name {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}

.cd-attach-doc-list {
  margin-top: 10px;
  padding-bottom: 5px;
}

.cd-form-headings {
  font-weight: 600;
  font-size: 14px;
  color: #6d6d6d;
}

.cd-attach-list {
  min-height: 47px;
  width: 100%;
  background: #fdfdfd;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}

.cd-right-container {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  height: calc(100vh - 150px);
  padding: 15px;
  width: 30%;
  position: relative;
}

.cd-detail-box {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  padding: 15px;
}

.cd-title-text {
  font-weight: 600;
  font-size: 14px;
  color: #72738e;
}

.cd-desc-text {
  font-weight: 400;
  font-size: 13px;
  color: #8b8b8b;
}

.cd-docs-container {
  height: 55px;
  padding: 10px;
  background: #efefef;
  border-radius: 5px;
}

.cd-left-container {
  background: #ffffff;
  border-radius: 8px;
  width: 70%;
  overflow: auto;
  height: calc(100vh - 150px);
}
</style>
